export default __webpack_public_path__ + "static/media/Andrew.e4c99b83.png";